import { useTextes } from '@common/config';
import { Z_TEXT } from '../primitives';

const t = useTextes('Commun', 'Formulaire');

export const SIREN_REGEX = /^\d{9}$/;

export const Z_SIREN = Z_TEXT(t['DETAIL_OFA_INFO_MODIF_MSG_SIREN'])
  .regex(SIREN_REGEX, { error: 'Le SIREN doit être composé de 9 chiffres.' });

export const SIREN_PLACEHOLDER = '123456789';